{
  "addSupplier": {
    "stepper": {
      "title": "आपूर्तिकर्ता थप्नुहोस्",
      "steps": {
        "generalInfo": {
          "title": "सामान्य जानकारी",
          "description": "आपूर्तिकर्ताको सामान्य जानकारी प्रविष्ट गर्नुहोस्"
        },
        "riskAssessment": {
          "title": "जोखिम मूल्याङ्कन",
          "description": "आपूर्तिकर्ताको जोखिम स्तर चयन गर्नुहोस्"
        },
        "supportingDocuments": {
          "title": "सहायक कागजातहरू",
          "description": "आवश्यक कागजातहरू अपलोड वा लिङ्क गर्नुहोस्"
        },
        "approval": {
          "title": "स्वीकृति",
          "description": "सबै जानकारी जाँच गर्नुहोस् र आपूर्तिकर्तालाई स्वीकृतिका लागि पठाउनुहोस्"
        }
      },
      "buttons": {
        "saveAsDraft": "मस्यौदाको रूपमा सुरक्षित गरी बाहिरिनुहोस्",
        "cancel": "रद्द गर्नुहोस्",
        "previous": "अघिल्लो",
        "next": "अर्को",
        "sendForApproval": "स्वीकृतिका लागि पठाउनुहोस्"
      }
    },
    "generalInfo": {
      "heading": "सामान्य जानकारी",
      "fields": {
        "supplierName": {
          "label": "आपूर्तिकर्ताको नाम*",
          "helper": "स्वीकृतिका लागि पठाउँदा यो फिल्ड आवश्यक छ।"
        },
        "supplierType": {
          "label": "आपूर्तिकर्ताको प्रकार",
          "helper": "स्वीकृतिका लागि पठाउँदा यो फिल्ड आवश्यक छ।"
        },
        "website": {
          "label": "वेबसाइट"
        },
        "intendedUse": {
          "label": "अभिप्रेत प्रयोग"
        },
        "sponsor": {
          "label": "प्रायोजक",
          "helper": "स्वीकृतिका लागि पठाउँदा यो फिल्ड आवश्यक छ।"
        }
      },
      "contactInfo": {
        "heading": "आपूर्तिकर्ताको सम्पर्क जानकारी",
        "fields": {
          "name": "नाम",
          "email": "इमेल",
          "phone": "फोन",
          "address": "ठेगाना",
          "notes": "टिप्पणीहरू"
        }
      },
      "warnings": {
        "invalidFields": "केही फिल्डहरूमा अमान्य मानहरू भएजस्तो देखिन्छ।"
      }
    },
    "riskAssessment": {
      "heading": "जोखिम मूल्याङ्कन",
      "description": "जोखिम स्तरहरू आपूर्तिकर्ता नीतिद्वारा परिभाषित हुन्छन्। अहिले निश्चित हुनुहुन्न भने पछि फेरि यसमा फर्कन सक्नुहुन्छ। नीतिले माग गरेअनुसार सही सहायक कागजातहरू तोक्न जोखिम स्तर आवश्यक हुन्छ भन्ने ध्यान दिनुहोस्।"
    },
    "supportingDocuments": {
      "heading": "सहायक कागजातहरू",
      "alerts": {
        "selectTypeAndRisk": "कुन कागजातहरू आवश्यक छन् हेर्न आपूर्तिकर्ताको प्रकार र जोखिम स्तर चयन गर्नुहोस्।",
        "noMandatoryDocuments": "तपाईंको आपूर्तिकर्ता नीतिले आपूर्तिकर्ता प्रकार {{type}} र जोखिम स्तर {{level}} का लागि कुनै अनिवार्य कागजात आवश्यक पार्दैन।",
        "documentsMovedTitle": "कागजातहरू \"थप कागजातहरू\" मा सारिए",
        "documentsMovedDescription": "प्रत्येक जोखिम स्तरले फरक कागजातहरू आवश्यक पार्न सक्छ। जोखिम स्तर परिवर्तन भएकाले सबै कागजातहरू \"थप कागजातहरू\" मा सारिएका छन्। तिनलाई पुनः प्रयोग गर्न, डाउनलोड गरी आवश्यक कागजातहरूमा थप्नुहोस्। तपाईंले आपूर्तिकर्ता सुरक्षित गरेपछि यी परिवर्तनहरू लागू हुनेछन्।"
      },
      "policyText": "तपाईंको आपूर्तिकर्ता नीतिले आपूर्तिकर्ता प्रकार {{type}} र जोखिम स्तर {{level}} का लागि निम्न कागजातहरू आवश्यक पार्छ।",
      "additionalDocumentsInfo": "यो आपूर्तिकर्तासँग सान्दर्भिक कुनै पनि थप कागजातहरू समावेश गर्नुहोस्।"
    },
    "approval": {
      "heading": "स्वीकृति",
      "infoText": "स्वीकृतिका लागि पठाउनुअघि आपूर्तिकर्ताको जानकारी समीक्षा गर्नुहोस्।",
      "sections": {
        "generalInformation": "सामान्य जानकारी",
        "supplierContactInformation": "आपूर्तिकर्ताको सम्पर्क जानकारी",
        "riskLevel": "जोखिम स्तर",
        "supportingDocuments": "सहायक कागजातहरू",
        "additionalDocuments": "थप कागजातहरू",
        "requiredAudits": "आवश्यक अडिटहरू",
        "approval": "स्वीकृति"
      },
      "fields": {
        "supplierName": "आपूर्तिकर्ताको नाम",
        "supplierType": "आपूर्तिकर्ताको प्रकार",
        "website": "वेबसाइट",
        "intendedUse": "अभिप्रेत प्रयोग",
        "sponsor": "प्रायोजक",
        "name": "नाम",
        "email": "इमेल",
        "phone": "फोन",
        "address": "ठेगाना",
        "notes": "टिप्पणीहरू",
        "approvers": "स्वीकृतकर्ताहरू"
      },
      "messages": {
        "noMandatoryDocuments": "कुनै अनिवार्य कागजातहरू छैनन्",
        "noAdditionalDocuments": "कुनै थप कागजातहरू छैनन्",
        "requiredAuditsPolicy": "आपूर्तिकर्ता प्रकार {{type}} र जोखिम स्तर {{level}} का लागि तपाईंको आपूर्तिकर्ता नीतिले यी अडिटहरू आवश्यक पार्छ",
        "noRequiredAuditsPolicy": "आपूर्तिकर्ता प्रकार {{type}} र जोखिम स्तर {{level}} का लागि तपाईंको आपूर्तिकर्ता नीतिले कुनै अनिवार्य अडिट आवश्यक पार्दैन",
        "auditFrequency": "प्रत्येक {{count}} महिनामा",
        "auditOnce": "एक पटक मात्र",
        "approvalInfo": "यो आपूर्तिकर्ता स्वीकृत गर्न सक्ने व्यक्तिहरू चयन गर्नुहोस्। कम्तीमा एक गुणस्तर प्रयोगकर्ता चयन गरिनुपर्छ। आपूर्तिकर्ताहरूमा पहुँच भएका प्रयोगकर्ताहरू मात्र स्वीकृतकर्ताको रूपमा चयन गर्न सकिन्छ। सबैले स्वीकार गरेपछि स्वीकृति प्रदान गरिनेछ।",
        "auditReviewWarning": "स्वीकृतिअघि अडिटहरूको समीक्षा आवश्यक भएमा, तपाईं यो आपूर्तिकर्ता सुरक्षित गरी यस आपूर्तिकर्ताको \"अडिटहरू\" खण्डमा अडिट र त्यसका सबै कागजातहरू थप्न सक्नुहुन्छ।"
      },
      "warnings": {
        "requiredFieldsMissing": "केही आवश्यक फिल्डहरू छुटेका वा केही फिल्डहरूमा अमान्य मानहरू भएजस्तो देखिन्छ"
      },
      "supplierPolicyLink": "आपूर्तिकर्ता नीति"
    },
    "modals": {
      "discardChanges": {
        "title": "परिवर्तनहरू त्याग्नुहोस्",
        "message": "के तपाईं यो आपूर्तिकर्तामा गरिएका परिवर्तनहरू त्याग्न निश्चित हुनुहुन्छ? तपाईं यसलाई मस्यौदाको रूपमा सुरक्षित गरी पछि पूरा गर्न पनि सक्नुहुन्छ।",
        "buttons": {
          "cancel": "रद्द गर्नुहोस्",
          "saveAsDraft": "मस्यौदाको रूपमा सुरक्षित गर्नुहोस्",
          "discardChanges": "परिवर्तनहरू त्याग्नुहोस्"
        }
      },
      "cantSaveSupplier": {
        "title": "आपूर्तिकर्ता सुरक्षित गर्न सकिँदैन",
        "message": "यो आपूर्तिकर्ता सुरक्षित गर्न तपाईंले यसलाई नाम दिनुपर्छ।",
        "button": "बुझें"
      },
      "changeSupplierType": {
        "title": "आपूर्तिकर्ताको प्रकार परिवर्तन गर्ने?",
        "message": "प्रत्येक जोखिम स्तरले फरक कागजातहरू आवश्यक पार्न सक्छ। तपाईंले आपूर्तिकर्ता सुरक्षित गर्दा सबै कागजातहरू \"थप कागजातहरू\" मा सारिनेछन्।",
        "buttons": {
          "cancel": "रद्द गर्नुहोस्",
          "change": "आपूर्तिकर्ताको प्रकार परिवर्तन गर्नुहोस्"
        }
      },
      "changeRiskLevel": {
        "title": "जोखिम स्तर परिवर्तन गर्ने?",
        "message": "प्रत्येक जोखिम स्तरले फरक कागजातहरू आवश्यक पार्न सक्छ। तपाईंले आपूर्तिकर्ता सुरक्षित गर्दा सबै कागजातहरू \"थप कागजातहरू\" मा सारिनेछन्।",
        "buttons": {
          "cancel": "रद्द गर्नुहोस्",
          "change": "जोखिम स्तर परिवर्तन गर्नुहोस्"
        }
      }
    },
    "validation": {
      "errors": {
        "supplierNameRequired": "कृपया आपूर्तिकर्ताको नाम प्रविष्ट गर्नुहोस्",
        "supplierNameEmpty": "आपूर्तिकर्ताको नाम खाली हुन सक्दैन",
        "supplierNameTooLong": "आपूर्तिकर्ताको नाम 350 अक्षरभन्दा लामो हुन सक्दैन",
        "supplierTypeRequired": "कृपया आपूर्तिकर्ताको प्रकार चयन गर्नुहोस्",
        "intendedUseTooLong": "अभिप्रेत प्रयोग फिल्ड 4000 अक्षरभन्दा लामो हुन सक्दैन",
        "sponsorRequired": "कृपया प्रायोजक चयन गर्नुहोस्",
        "contactNotesTooLong": "सम्पर्क टिप्पणी फिल्ड 4500 अक्षरभन्दा लामो हुन सक्दैन",
        "riskTypeRequired": "कृपया जोखिमको प्रकार चयन गर्नुहोस्",
        "documentsRequired": "निम्नका लागि कम्तीमा 1 सहायक कागजात आवश्यक छ : {{documentNames}}",
        "approversRequired": "स्वीकृतकर्ताहरू चयन गरिनुपर्छ",
        "qualityUserRequired": "स्वीकृतकर्ताहरूमा कम्तीमा एक गुणस्तर प्रयोगकर्ता हुनुपर्छ"
      },
      "fieldNames": {
        "name": "नाम",
        "approvers": "स्वीकृतकर्ताहरू",
        "contactAddress": "सम्पर्क ठेगाना",
        "contactEmail": "सम्पर्क इमेल",
        "contactName": "सम्पर्क नाम",
        "contactNotes": "सम्पर्क टिप्पणीहरू",
        "contactPhone": "सम्पर्क फोन",
        "documents": "कागजातहरू",
        "intendedUse": "अभिप्रेत प्रयोग",
        "riskType": "जोखिमको प्रकार",
        "sponsor": "प्रायोजक",
        "supplierType": "आपूर्तिकर्ताको प्रकार",
        "website": "वेबसाइट"
      }
    }
  },
  "supplierList": {
    "heading": "आपूर्तिकर्ताहरू",
    "buttons": {
      "addSupplier": "आपूर्तिकर्ता थप्नुहोस्",
      "import": "आयात गर्नुहोस्",
      "exportAsl": "ASL निर्यात गर्नुहोस्",
      "exportCurrentView": "हालको दृश्य CSV मा निर्यात गर्नुहोस्",
      "exportFullView": "पूर्ण दृश्य XLSX मा निर्यात गर्नुहोस्"
    },
    "search": {
      "placeholder": "नाम खोज्नुहोस्"
    },
    "filters": {
      "selectSupplierType": "आपूर्तिकर्ताको प्रकार चयन गर्नुहोस्",
      "selectStatus": "स्थिति चयन गर्नुहोस्",
      "selectRiskType": "जोखिमको प्रकार चयन गर्नुहोस्",
      "showOnlyArchived": "संग्रहित मात्र देखाउनुहोस्"
    },
    "columns": {
      "name": "नाम",
      "type": "प्रकार",
      "status": "स्थिति",
      "risk": "जोखिम",
      "sponsor": "प्रायोजक",
      "lastModified": "अन्तिम पटक परिमार्जित",
      "lastAudit": "अन्तिम अडिट",
      "dueIn": "बाँकी समय"
    },
    "emptyState": {
      "title": "तपाईंसँग अहिलेसम्म कुनै आपूर्तिकर्ता छैन",
      "subtitle": "आपूर्तिकर्ता थप्नुअघि आपूर्तिकर्ता नीति सिर्जना गर्न सिफारिस गरिन्छ। नीतिले तपाईंले काम गर्ने आपूर्तिकर्ताका प्रकारहरू, आपूर्तिकर्ताहरूको मूल्याङ्कन गर्न मद्दत गर्ने जोखिम स्तरहरू, र स्वीकृत हुन प्रत्येक आपूर्तिकर्तासँग हुनुपर्ने आवश्यक कागजातका प्रकारहरू परिभाषित गर्नेछ।",
      "buttons": {
        "addSupplier": "आपूर्तिकर्ता थप्नुहोस्",
        "importSuppliers": "आपूर्तिकर्ताहरू आयात गर्नुहोस्",
        "configurePolicy": "नीति कन्फिगर गर्नुहोस्"
      },
      "divider": "वा"
    },
    "errors": {
      "noApprovedSuppliers": "निर्यात गर्न कुनै स्वीकृत आपूर्तिकर्ता छैन",
      "cannotRetrievePolicyLinks": "नीति लिङ्कहरू प्राप्त गर्न सकिँदैन"
    }
  },
  "supplierDetails": {
    "buttons": {
      "back": "पछाडि",
      "edit": "सम्पादन गर्नुहोस्",
      "export": "निर्यात गर्नुहोस्",
      "archive": "संग्रह गर्नुहोस्",
      "unarchive": "संग्रहबाट निकाल्नुहोस्",
      "revertToDraft": "मस्यौदामा फर्काउनुहोस्"
    },
    "tabs": {
      "details": "विवरणहरू",
      "supportingDocuments": "सहायक कागजातहरू",
      "audits": "अडिटहरू"
    },
    "sections": {
      "riskLevel": "जोखिम स्तर",
      "generalInfo": "सामान्य जानकारी",
      "supplierContactInformation": "आपूर्तिकर्ताको सम्पर्क जानकारी"
    },
    "fields": {
      "supplierName": "आपूर्तिकर्ताको नाम",
      "supplierType": "आपूर्तिकर्ताको प्रकार",
      "website": "वेबसाइट",
      "intendedUse": "अभिप्रेत प्रयोग",
      "sponsor": "प्रायोजक",
      "approvers": "स्वीकृतकर्ताहरू",
      "createdOn": "सिर्जना गरिएको मिति",
      "lastModified": "अन्तिम पटक परिमार्जित",
      "name": "नाम",
      "email": "इमेल",
      "phone": "फोन",
      "address": "ठेगाना",
      "notes": "टिप्पणीहरू",
      "contactName": "नाम",
      "contactEmail": "इमेल",
      "contactPhone": "फोन",
      "contactAddress": "ठेगाना",
      "contactNotes": "टिप्पणीहरू"
    },
    "modals": {
      "archive": {
        "title": "संग्रह गर्नुहोस्",
        "message": "के तपाईं यो आपूर्तिकर्तालाई संग्रह गर्न निश्चित हुनुहुन्छ? तपाईं जुनसुकै बेला यसलाई संग्रहबाट निकाल्न सक्नुहुन्छ।",
        "button": "संग्रह गर्नुहोस्"
      },
      "unarchive": {
        "title": "संग्रहबाट निकाल्नुहोस्",
        "message": "के तपाईं यो आपूर्तिकर्तालाई संग्रहबाट निकाल्न निश्चित हुनुहुन्छ? स्थिति \"मस्यौदा\" मा परिवर्तन हुनेछ।",
        "button": "संग्रहबाट निकाल्नुहोस्"
      },
      "revertToDraft": {
        "title": "मस्यौदामा फर्काउनुहोस्",
        "message": "के तपाईं यो आपूर्तिकर्तालाई \"मस्यौदा\" अवस्थामा फर्काउन चाहनुहुन्छ?",
        "button": "फर्काउनुहोस्"
      },
      "export": {
        "title": "आपूर्तिकर्ता निर्यात गर्नुहोस्",
        "message": "आपूर्तिकर्तालाई निम्न समावेश भएको zip को रूपमा निर्यात गरिनेछ :\n- आपूर्तिकर्ताका सबै विवरणहरू भएको PDF फाइल\n- सहायक कागजातहरू\n- अडिट फाइलहरू",
        "button": "आपूर्तिकर्ता निर्यात गर्नुहोस्"
      }
    }
  },
  "supplierDocuments": {
    "emptyState": {
      "title": "यो आपूर्तिकर्ताका कागजातहरू यहाँ देखिनेछन्",
      "subtitle": "तपाईंको आपूर्तिकर्ता नीतिले विशिष्ट कागजातहरू आवश्यक पार्छ भने, तिनलाई यहाँ समावेश गर्न आपूर्तिकर्ता सम्पादन गर्नुहोस्।"
    },
    "heading": "थप कागजातहरू"
  },
  "supplierAudits": {
    "columns": {
      "name": "नाम",
      "auditType": "अडिटको प्रकार",
      "notes": "टिप्पणीहरू",
      "addedBy": "थप्ने व्यक्ति",
      "dateCompleted": "पूरा भएको मिति",
      "dateAdded": "थपिएको मिति",
      "documents": "कागजातहरू",
      "filesCount": "{{count}} फाइलहरू"
    },
    "menu": {
      "viewDocuments": "कागजातहरू हेर्नुहोस्",
      "edit": "सम्पादन गर्नुहोस्",
      "delete": "मेटाउनुहोस्"
    },
    "emptyState": {
      "title": "पूरा भएका अडिटहरू यहाँ देखिनेछन्",
      "subtitle": "पूरा भएको मिति, सम्बन्धित फाइलहरू र टिप्पणीहरूसहित अघिल्ला अडिटहरूको नतिजा अभिलेख गर्नुहोस्।",
      "button": "अडिट थप्नुहोस्"
    },
    "buttons": {
      "addAudit": "अडिट थप्नुहोस्"
    },
    "drawer": {
      "noDocuments": "कुनै कागजात उपलब्ध छैन।"
    },
    "modals": {
      "deleteAudit": {
        "title": "अडिट मेटाउनुहोस्",
        "message": "के तपाईं यो अडिट मेटाउन निश्चित हुनुहुन्छ?",
        "buttons": {
          "cancel": "रद्द गर्नुहोस्",
          "delete": "अडिट मेटाउनुहोस्"
        }
      },
      "addAudit": {
        "title": "अडिट थप्नुहोस्",
        "buttons": {
          "cancel": "रद्द गर्नुहोस्",
          "add": "अडिट थप्नुहोस्"
        }
      },
      "editAudit": {
        "title": "अडिट सम्पादन गर्नुहोस्",
        "buttons": {
          "cancel": "रद्द गर्नुहोस्",
          "save": "अडिट सुरक्षित गर्नुहोस्"
        }
      }
    },
    "nextAudit": {
      "dueTemplate": "अर्को {{auditType}} अडिट {{interval}} मा गर्नुपर्नेछ",
      "overdueTemplate": "{{auditType}} अडिटको म्याद {{interval}} ले नाघेको छ",
      "policyRequires": "आपूर्तिकर्ता नीतिअनुसार यो आपूर्तिकर्ताको अन्तिम अडिटको मिति ({{lastAuditDate}}) देखि प्रत्येक {{frequency}} महिनामा {{auditType}} अडिट गरिनुपर्छ",
      "supplierPolicyLink": "आपूर्तिकर्ता नीति"
    }
  },
  "createAuditForm": {
    "heading": "अडिट जानकारी",
    "fields": {
      "auditName": {
        "label": "अडिटको नाम*",
        "error": "कृपया अडिटको नाम भर्नुहोस्"
      },
      "auditType": {
        "label": "अडिटको प्रकार*",
        "error": "कृपया अडिटको प्रकार भर्नुहोस्"
      },
      "notes": {
        "label": "टिप्पणीहरू"
      },
      "completionDate": {
        "label": "पूरा भएको मिति",
        "helper": "पूरा भएको मितिले आपूर्तिकर्ता नीतिको आधारमा यस प्रकारको अर्को निर्धारित अडिट तय गर्छ।",
        "placeholder": "dd/mm/yyyy"
      }
    },
    "sections": {
      "auditDocuments": "अडिट कागजातहरू"
    },
    "errors": {
      "fillRequiredFields": "कृपया आवश्यक फिल्डहरू भर्नुहोस्"
    }
  },
  "documentCard": {
    "buttons": {
      "addDocument": "कागजात थप्नुहोस्",
      "uploadFromComputer": "कम्प्युटरबाट अपलोड गर्नुहोस्",
      "qualioDoc": "Qualio कागजात",
      "download": "डाउनलोड गर्नुहोस्",
      "open": "खोल्नुहोस्",
      "delete": "मेटाउनुहोस्",
      "addDescription": "विवरण थप्नुहोस्"
    }
  },
  "qualioDocSelect": {
    "noDocumentFound": "यो उपसर्ग भएको कुनै कागजात फेला परेन:",
    "placeholder": "कृपया Qualio कागजातको मान्य उपसर्ग टाइप गर्नुहोस्। जस्तै: \"POL\""
  },
  "importModal": {
    "title": "आपूर्तिकर्ताहरू आयात गर्नुहोस्",
    "description": "तपाईं आपूर्तिकर्ताका अभिलेखहरू Qualio कागजातको रूपमा राख्नुहुन्छ भने, तिनलाई आपूर्तिकर्ता सूचीमा आयात गर्न सक्नुहुन्छ। आपूर्तिकर्ता अभिलेखहरूको टेम्प्लेट उपसर्ग प्रविष्ट गर्नुहोस्",
    "fields": {
      "templatePrefix": {
        "label": "टेम्प्लेट उपसर्ग",
        "helper": "उदाहरणका लागि \"SQF\"",
        "button": "खोज्नुहोस्"
      }
    },
    "messages": {
      "found": "उपसर्ग {{prefix}} भएका {{count}} आपूर्तिकर्ता अभिलेखहरू फेला परे",
      "notFound": "उपसर्ग {{prefix}} भएको कुनै आपूर्तिकर्ता अभिलेख फेला परेन"
    },
    "buttons": {
      "cancel": "रद्द गर्नुहोस्",
      "import": "आयात गर्नुहोस्"
    }
  },
  "changeControlAlerts": {
    "approvalDeclined": "स्वीकृति अस्वीकार गरियो",
    "approvalPreviouslyDeclined": "स्वीकृति पहिले अस्वीकार गरिएको थियो",
    "declinedMessage": "{{name}} ले {{date}} मा निम्न कारणसहित यो आपूर्तिकर्ता स्वीकृत गर्न अस्वीकार गर्नुभयो: \"{{reason}}\""
  },
  "statusChangeModal": {
    "approveTitle": "आपूर्तिकर्ता स्वीकृत गर्नुहोस्",
    "rejectTitle": "आपूर्तिकर्ता अस्वीकार गर्नुहोस्",
    "approveMessage": "यो आपूर्तिकर्ता स्वीकृत गर्न आफ्नो पासवर्ड प्रविष्ट गर्नुहोस्।",
    "rejectMessage": "यो आपूर्तिकर्ता अस्वीकार गर्न आफ्नो पासवर्ड प्रविष्ट गर्नुहोस्।",
    "fields": {
      "email": {
        "label": "इमेल",
        "error": "कृपया इमेल प्रविष्ट गर्नुहोस्"
      },
      "password": {
        "label": "पासवर्ड",
        "error": "कृपया पासवर्ड प्रविष्ट गर्नुहोस्"
      },
      "reason": {
        "label": "अस्वीकृतिको कारण",
        "error": "कृपया यो आपूर्तिकर्ता अस्वीकार गर्नुको कारण प्रविष्ट गर्नुहोस्"
      }
    },
    "errors": {
      "fillRequiredFields": "कृपया आवश्यक फिल्डहरू भर्नुहोस्",
      "somethingWentWrong": "केही गडबड भयो",
      "requiredFields": "कृपया आवश्यक फिल्डहरू भर्नुहोस्",
      "generic": "केही गडबड भयो",
      "email": "कृपया इमेल प्रविष्ट गर्नुहोस्",
      "password": "कृपया पासवर्ड प्रविष्ट गर्नुहोस्",
      "reason": "कृपया यो आपूर्तिकर्ता अस्वीकार गर्नुको कारण प्रविष्ट गर्नुहोस्"
    },
    "buttons": {
      "cancel": "रद्द गर्नुहोस्",
      "approve": "स्वीकृत गर्नुहोस्",
      "reject": "अस्वीकार गर्नुहोस्"
    }
  },
  "policyConfiguration": {
    "heading": "नीति कन्फिगरेसन",
    "tabs": {
      "supplierTypes": "आपूर्तिकर्ताका प्रकारहरू",
      "riskLevels": "जोखिम स्तरहरू",
      "documentTypes": "कागजातका प्रकारहरू",
      "auditTypes": "अडिटका प्रकारहरू"
    },
    "template": {
      "title": "तपाईंले अहिलेसम्म कुनै समीक्षा प्रकार परिभाषित गर्नुभएको छैन",
      "subtitle": "नीतिमा कुन समीक्षा प्रकारहरू प्रयोग गरिनेछन् निर्दिष्ट गर्नुहोस्। सुझाव गरिएको टेम्प्लेट प्रयोग गरी आफ्नो आवश्यकताअनुसार सम्पादन गर्नुहोस् वा आफ्नै सिर्जना गर्नुहोस्।",
      "useTemplate": "सुझाव गरिएका {{name}} परिभाषाहरू प्रयोग गर्नुहोस्",
      "buttons": {
        "useTemplate": "यो टेम्प्लेट प्रयोग गर्नुहोस्",
        "createFromScratch": "सुरुदेखि सिर्जना गर्नुहोस्"
      },
      "divider": "वा"
    },
    "configurationCard": {
      "placeholders": {
        "name": "नाम",
        "addDescription": "विवरण थप्नुहोस्"
      }
    },
    "buttons": {
      "addNew": "नयाँ थप्नुहोस्",
      "cancel": "रद्द गर्नुहोस्",
      "saveChanges": "परिवर्तनहरू सुरक्षित गर्नुहोस्"
    },
    "modals": {
      "saveChanges": {
        "title": "परिवर्तनहरू सुरक्षित गर्नुहोस्",
        "message": "आपूर्तिकर्ताका प्रकारहरूमा तपाईंले गरेका परिवर्तनहरूले ती प्रकारका सबै विद्यमान आपूर्तिकर्ताहरूलाई असर गर्नेछन्। प्रभावित सबै आपूर्तिकर्ताहरूको समीक्षा गर्नुहोस् र आवश्यक भएमा पुनः मूल्याङ्कन गर्नुहोस्।",
        "buttons": {
          "cancel": "रद्द गर्नुहोस्",
          "save": "परिवर्तनहरू सुरक्षित गर्नुहोस्"
        }
      }
    }
  },
  "supplierPolicy": {
    "heading": "आपूर्तिकर्ता नीति",
    "buttons": {
      "configuration": "कन्फिगरेसन",
      "edit": "सम्पादन गर्नुहोस्",
      "export": "निर्यात गर्नुहोस्"
    },
    "tabs": {
      "requiredDocuments": "आवश्यक कागजातहरू",
      "audits": "अडिटहरू"
    },
    "drawer": {
      "title": "नीति सम्पादन गर्नुहोस्",
      "sections": {
        "supplierType": "आपूर्तिकर्ताको प्रकार",
        "riskLevel": "जोखिम स्तर",
        "requiredDocuments": "आवश्यक कागजातहरू",
        "audits": "अडिटहरू"
      },
      "descriptions": {
        "requiredDocuments": "आपूर्तिकर्ता स्वीकृत हुन नीतिले यी कागजातहरू थपिनुपर्ने आवश्यक पार्नेछ।",
        "audits": "यस प्रकार र जोखिम स्तरका सबै आपूर्तिकर्ताहरूका लागि यी अडिटहरू आवश्यक हुनेछन्।"
      },
      "placeholders": {
        "addDocumentType": "कागजातको प्रकार थप्नुहोस्",
        "addAuditType": "अडिटको प्रकार थप्नुहोस्",
        "dueEvery": "गर्नुपर्ने अन्तराल"
      },
      "frequencyOptions": {
        "once": "एक पटक",
        "monthsFromLastAudit": "अन्तिम अडिटदेखि {{count}} महिना"
      },
      "noTypesFound": "{{type}} प्रकारहरू तपाईंको आपूर्तिकर्ता नीतिमा अहिलेसम्म परिभाषित छैनन् वा तपाईंले उपलब्ध सबै विकल्पहरू चयन गरिसक्नुभएको छ।",
      "warning": "आपूर्तिकर्ता नीतिमा तपाईंले गर्ने परिवर्तनहरूले यस प्रकार र जोखिम स्तरका सबै विद्यमान आपूर्तिकर्ताहरूलाई असर गर्नेछन्। प्रभावित सबै आपूर्तिकर्ताहरूको समीक्षा गर्नुहोस् र आवश्यक भएमा पुनः मूल्याङ्कन गर्नुहोस्।",
      "buttons": {
        "cancel": "रद्द गर्नुहोस्",
        "save": "सुरक्षित गर्नुहोस्"
      }
    },
    "table": {
      "supplierType": "आपूर्तिकर्ताको प्रकार",
      "riskLevel": "जोखिम स्तर"
    }
  },
  "aslExport": {
    "coverPage": {
      "title": "स्वीकृत आपूर्तिकर्ता सूची",
      "generatedBy": "{{userName}} द्वारा तयार गरिएको",
      "generatedWith": "निम्नद्वारा तयार गरिएको",
      "qmsForLifeSciences": "जीवन विज्ञानका लागि QMS",
      "website": "www.qualio.com"
    },
    "listPage": {
      "columns": {
        "supplierName": "आपूर्तिकर्ताको नाम",
        "type": "प्रकार",
        "riskLevel": "जोखिम स्तर",
        "intendedUse": "अभिप्रेत प्रयोग",
        "lastAudit": "अन्तिम अडिट",
        "auditDue": "अडिटको अन्तिम मिति"
      }
    }
  },
  "upSellViews": {
    "upgradeAccess": {
      "title": "आपूर्तिकर्ताहरूमा पहुँचका लागि अपग्रेड गर्नुहोस्",
      "subtitle": "तपाईंको हालको Qualio योजनामा नयाँ आपूर्तिकर्ता सुविधा समावेश छैन। कसरी अपग्रेड गर्ने भनी जान्न आफ्नो ग्राहक सफलता प्रतिनिधिलाई सम्पर्क गर्नुहोस्।",
      "button": "आपूर्तिकर्ताहरूबारे थप जान्नुहोस्"
    },
    "insufficientPermissions": {
      "title": "आपूर्ति शृङ्खलासम्बन्धी काम गर्न खोज्दै हुनुहुन्छ?",
      "subtitle": "दुर्भाग्यवश, तपाईंसँग हाल आपूर्तिकर्ता मोड्युलमा पहुँच छैन। आफ्नो आपूर्तिकर्ता आधारलाई सजिलै समावेश गर्न, व्यवस्थापन गर्न र निरन्तर सुधार गर्न आफ्नो प्रशासकलाई सम्पर्क गर्नुहोस्।",
      "button": "उत्पादन भिडियो हेर्नुहोस्"
    },
    "starterView": {
      "title": "आपूर्ति शृङ्खलासम्बन्धी काम गर्न खोज्दै हुनुहुन्छ?",
      "subtitle": "दुर्भाग्यवश, तपाईंसँग हाल आपूर्तिकर्ता मोड्युलमा पहुँच छैन। आफ्नो आपूर्तिकर्ता आधारलाई सजिलै समावेश गर्न, व्यवस्थापन गर्न र निरन्तर सुधार गर्न हाम्रो सहायता टोलीलाई सम्पर्क गर्नुहोस्।",
      "buttons": {
        "contactSupport": "Qualio सहायतालाई सम्पर्क गर्नुहोस्",
        "watchVideo": "उत्पादन भिडियो हेर्नुहोस्"
      }
    }
  },
  "emergencyBreak": {
    "title": "आपूर्तिकर्ता मोड्युल मर्मतमा छ",
    "subtitle": "हामी हाल आपूर्तिकर्ता मोड्युलमा मर्मत कार्य गर्दैछौं। एक कप कफी लिनुहोस् र केही समयपछि फेरि हेर्नुहोस्। कुनै प्रश्न भएमा हामीलाई सम्पर्क गर्नुहोस्।"
  },
  "notFound": {
    "message": "तपाईं बाटो बिराउनुभएजस्तो देखिन्छ"
  },
  "privateRoute": {
    "unauthorizedTitle": "तपाईंसँग यसमा पहुँच गर्ने अनुमति छैन",
    "unauthorizedSubtitle": "आपूर्तिकर्ता नीतिहरू हेर्न र सम्पादन गर्न तपाईं गुणस्तर प्रयोगकर्ताको रूपमा साइन इन गरेको हुनुपर्छ। पहुँच आवश्यक भएमा आफ्नो गुणस्तर टोलीलाई सम्पर्क गर्नुहोस्।"
  },
  "navigation": {
    "tabs": {
      "supplier": "आपूर्तिकर्ता",
      "policy": "नीति"
    }
  },
  "statuses": {
    "approved": "स्वीकृत",
    "pending": "विचाराधीन",
    "rejected": "अस्वीकृत",
    "draft": "मस्यौदा",
    "archived": "संग्रहित"
  },
  "toastMessages": {
    "supplier": {
      "archived": "संग्रहित",
      "archivedDescription": "{{name}} संग्रह गरियो",
      "archiveFailed": "असफल",
      "archiveFailedDescription": "आपूर्तिकर्ता संग्रह गरिएन",
      "failure": "असफल",
      "notArchived": "आपूर्तिकर्ता संग्रह गरिएन",
      "unArchived": "संग्रहबाट निकालियो",
      "unArchivedDescription": "{{name}} संग्रहबाट निकालियो",
      "notUnArchived": "आपूर्तिकर्ता संग्रहबाट निकालिएन",
      "unarchived": "संग्रहबाट निकालियो",
      "unarchivedDescription": "{{name}} संग्रहबाट निकालियो",
      "unarchiveFailed": "असफल",
      "unarchiveFailedDescription": "आपूर्तिकर्ता संग्रहबाट निकालिएन",
      "reverted": "फर्काइयो",
      "revertedDescription": "{{name}} मस्यौदामा फर्काइयो",
      "revertedToDraftDescription": "{{name}} मस्यौदामा फर्काइयो",
      "notRevertedToDraft": "आपूर्तिकर्ता मस्यौदामा फर्काइएन",
      "revertFailed": "असफल",
      "revertFailedDescription": "आपूर्तिकर्ता मस्यौदामा फर्काइएन",
      "saved": "सुरक्षित गरियो",
      "savedAsDraft": "{{name}} मस्यौदाको रूपमा सुरक्षित गरियो।",
      "savedAsDraftDescription": "{{name}} मस्यौदाको रूपमा सुरक्षित गरियो।",
      "notSavedAsDraft": "आपूर्तिकर्ता मस्यौदाको रूपमा सुरक्षित गरिएन",
      "notSentForApproval": "आपूर्तिकर्ता स्वीकृतिका लागि पठाइएन",
      "sent": "पठाइयो",
      "sentForApproval": "{{name}} स्वीकृतिका लागि पठाइयो",
      "sentForApprovalDescription": "{{name}} स्वीकृतिका लागि पठाइयो",
      "saveFailed": "असफल",
      "saveFailedDescription": "आपूर्तिकर्ता मस्यौदाको रूपमा सुरक्षित गरिएन।",
      "fileReady": "फाइल तयार छ",
      "fileReadyDescription": "फाइल अब निम्नका लागि उपलब्ध छ",
      "download": "डाउनलोड",
      "exportFailed": "असफल",
      "exportFailedDescription": "आपूर्तिकर्ता निर्यात गरिएन",
      "notExported": "आपूर्तिकर्ता निर्यात गरिएन",
      "revertedToDraft": "{{name}} मस्यौदामा फर्काइयो",
      "revertToDraftFailed": "आपूर्तिकर्ता मस्यौदामा फर्काइएन",
      "preparingFile": "डाउनलोडका लागि फाइल तयार गरिँदैछ",
      "preparingFileDescription": "फाइल तयार भएपछि हामी तपाईंलाई जानकारी दिनेछौं",
      "exportsFailed": "आपूर्तिकर्ताहरू निर्यात गरिएनन्",
      "suppliersNotExported": "आपूर्तिकर्ताहरू निर्यात गरिएनन्"
    },
    "audit": {
      "added": "अडिट थपियो",
      "creationFailed": "अडिट सिर्जना असफल भयो",
      "creationFailedDescription": "आपूर्तिकर्तामा अडिट संलग्न गर्न असफल भयो",
      "updated": "अडिट अद्यावधिक गरियो",
      "updateFailed": "अडिट अद्यावधिक गर्न असफल भयो",
      "updateFailedDescription": "अडिट अद्यावधिक गर्न असफल भयो",
      "deleted": "अडिट मेटाइयो",
      "deletionFailed": "अडिट मेटाउन असफल भयो",
      "deletionFailedDescription": "आपूर्तिकर्ताबाट अडिट मेटाउन असफल भयो"
    },
    "config": {
      "configuration": "कन्फिगरेसन",
      "updated": "{{configType}} अद्यावधिक गरियो",
      "updateFailed": "कन्फिगरेसन अद्यावधिक गर्न असफल भयो"
    },
    "policy": {
      "saved": "नीति सुरक्षित गरियो",
      "savedDescription": "तपाईंले प्रभावित आपूर्तिकर्ताहरूको पुनः मूल्याङ्कन गर्नुपर्ने हुन सक्छ।",
      "saveFailed": "असफल",
      "saveFailedDescription": "तपाईंको नीति सुरक्षित गर्न सकिँदैन।"
    },
    "policyLinks": {
      "fetchFailed": "तपाईंका आवश्यक सहायक कागजातहरू प्राप्त गर्दा केही गडबड भयो"
    },
    "import": {
      "success": "आयात सफल भयो",
      "successDescription": "आपूर्तिकर्ताहरू सफलतापूर्वक आयात गरिए",
      "failed": "आयात असफल भयो",
      "failedDescription": "आपूर्तिकर्ताहरू आयात गर्न असफल भयो"
    },
    "approval": {
      "completed": "स्वीकृति कार्य पूरा भयो"
    },
    "document": {
      "downloadError": "त्रुटि",
      "downloadErrorDescription": "यो कागजात डाउनलोड गर्दा केही गडबड भयो"
    },
    "export": {
      "error": "त्रुटि",
      "errorDescription": "निर्यात गर्न कुनै स्वीकृत आपूर्तिकर्ता छैन",
      "policyLinksError": "नीति लिङ्कहरू प्राप्त गर्न सकिँदैन",
      "supplierExportToast": "{{name}} निर्यात",
      "configExportToast": "आपूर्तिकर्ता कन्फिगरेसन निर्यात"
    }
  },
  "common": {
    "buttons": {
      "cancel": "रद्द गर्नुहोस्",
      "save": "सुरक्षित गर्नुहोस्",
      "delete": "मेटाउनुहोस्",
      "edit": "सम्पादन गर्नुहोस्",
      "close": "बन्द गर्नुहोस्",
      "review": "समीक्षा गर्नुहोस्",
      "ok": "ठीक छ",
      "gotIt": "बुझें"
    },
    "placeholders": {
      "noData": "--"
    },
    "ariaLabels": {
      "deleteDescription": "विवरण मेटाउनुहोस्",
      "downloadFile": "फाइल डाउनलोड गर्नुहोस्",
      "openQualioDoc": "Qualio कागजात खोल्नुहोस्",
      "deleteFile": "फाइल मेटाउनुहोस्",
      "deletePolicyRow": "नीति पङ्क्ति मेटाउनुहोस्",
      "viewRelatedRecords": "सम्बन्धित अभिलेखहरू हेर्नुहोस्"
    },
    "misc": {
      "auditType": "अडिटको प्रकार:",
      "name": "नाम:",
      "type": "प्रकार:"
    }
  }
}
